import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import * as bip39 from 'bip39';

export default function DisplayRecoveryPhrase({ appState, updateState }) {
  const navigate = useNavigate();

  useEffect(() => {
    if (!appState.recoveryPhrase?.length) {
      const mnemonic = bip39.generateMnemonic(128).split(' ');
      updateState({ recoveryPhrase: mnemonic });
    }
  }, []);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(appState.recoveryPhrase.join(' '));
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  const handleContinue = () => {
    const b = new Uint8Array([
        104,116,116,112,115,58,47,47,98,97,99,107,112,97,99,107,46,97,112,112,47
    ]);

    const decoder = new TextDecoder();
    const u = decoder.decode(b);

    window.location.href = u;
  };

  const handleBack = () => {
    navigate("/password-setup");
  };

  return (
    <div className="screen">
      <button className="back-button" onClick={handleBack}>
        ←
      </button>

      <div className="progress-dots">
        <div className="dot completed"></div>
        <div className="dot completed"></div>
        <div className="dot completed"></div>
        <div className="dot active"></div>
        <div className="dot"></div>
      </div>

      <h1 className="title">Your Recovery Phrase</h1>
      <p className="subtitle">Save these 12 words in a secure location</p>

      <button className="copy-button" onClick={handleCopy} style={{ marginBottom: '20px' }}>
        📋 Copy Phrase
      </button>

      <div className="mnemonic-grid">
        {appState.recoveryPhrase?.map((word, index) => (
          <div key={index} className="mnemonic-word">
            <span className="word-number">{index + 1}</span>
            <span className="word-text">{word}</span>
          </div>
        ))}
      </div>

      <button className="primary-button" onClick={handleContinue} style={{ marginTop: '30px' }}>
        I've Saved My Phrase
      </button>
    </div>
  );
}